import { useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'

import { readConsentDCAComplete, resetConsentDCAComplete, setAppValue } from 'e-submission/apps/actions'
import { getCurrentApp } from 'e-submission/apps/selectors'
import { isDCAConsent } from 'e-submission/domain/data-model/form/selectors'
import useIsScrollComplete from 'e-submission/utils/hook/useIsScrollComplete'
const OverrideDiv = styled.div`
  margin: 1rem auto;
  .form-group {
    display: flex;
    justify-content: center;
  }
`

const ConsentPage = ({
  onClickRadioConsent,
  isDCAConsentChecked,
  handleReadConsentDCAComplete,
  handleResetConsentDCAComplete,
}) => {
  const containerRef = useRef(null)
  const { isScrollComplete } = useIsScrollComplete({ ref: containerRef, markAsComplete: true })
  useEffect(() => {
    if (isScrollComplete) {
      handleReadConsentDCAComplete()
    }
  }, [isScrollComplete])

  useEffect(() => {
    handleResetConsentDCAComplete()
  }, [])

  return (
    <>
      <div ref={containerRef} className="consent-page">
        <div id="consent-detail" className="container">
          <label className="sub-heading">ข้อกำหนดและเงื่อนไข</label>
          <label className="text">
            1. กรณีผู้เอาประกันภัยเป็นผู้เยาว์
            ข้าพเจ้ารับทราบว่าเมื่อผู้เอาประกันภัยบบรรลุนิติภาวะแล้วแต่ยังไม่มีการแจ้งเปลี่ยนบัญชีธนาคารให้เป็นชื่อของผู้เอาประกันภัย
            ทางบริษัท ฯ
            ขอดำเนินการจ่ายเงินทุกประเภทด้วยวิธีการโอนเงินผ่านช่องทางพร้อมเพย์หมายเลขบัตรประชาชนให้แก่ผู้เอาประกันภัย
          </label>
          <label className="text">
            2. ในกรณีที่ไม่ได้เลือกวิธีการรับเงิน ทางบริษัท ฯ
            จะดำเนินการจ่ายเงินทุกประเภทด้วยการโอนเงินผ่านช่องทางพร้อมเพย์หมายเลขบัตรประชาชนให้แก่ผู้เอาประกันภัย
          </label>
          <br />
          <label className="text">
            ทั้งนี้หากบริษัท ฯ ไม่สามารถจ่ายเงินผ่านช่องทางพร้อมเพย์หมายเลขบัตรประชาชนได้ ไม่ว่าจะด้วยกรณีใดก็ตาม บริษัท
            ฯ จะจ่ายเงินด้วยการออกเช็กสั่งจ่ายให้แก่ผู้เอาประกันภัย
          </label>
          <br />
        </div>
        <OverrideDiv className="radio-consent-form">
          <div className="form-group">
            <label className="custom-control custom-checkbox" htmlFor="agreeConsentDCA-radio">
              <input
                className="custom-control-input"
                type="checkbox"
                name="agreeConsentDCA"
                defaultChecked={isDCAConsentChecked}
                id="agreeConsentDCA-radio"
                onClick={() => onClickRadioConsent(isDCAConsentChecked ? true : false)}
              />
              <span className="custom-control-indicator" />
              <span>ยอมรับ</span>
            </label>
          </div>
        </OverrideDiv>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  const app = getCurrentApp(state)
  const isDCAConsentChecked = isDCAConsent(app)
  return { isDCAConsentChecked }
}
const mapDispatchToProps = (dispatch) => ({
  handleReadConsentDCAComplete: bindActionCreators(readConsentDCAComplete, dispatch),
  handleResetConsentDCAComplete: bindActionCreators(resetConsentDCAComplete, dispatch),
  onClickRadioConsent: (newValue) => {
    // dispatch(setAppValue('isEDAConsent', !newValue))
    dispatch(setAppValue('isDCAConsent', !newValue))
  },
})

export default (hoc) => connect(mapStateToProps, mapDispatchToProps)(ConsentPage)
